const state = {
  galleryEngin: {},
  galleryData: {},
  galleryActive: false,
};

const mutations = {
  SET_GALLERY_ENGIN(state, galleryEngin) {
    state.galleryEngin = galleryEngin;
  },
  CHANGE_GALLERY_CONTENT(state, galleryObj) {
    state.galleryData = galleryObj;
  },
  GALLERY_ACTIVATE(state) {
    state.galleryActive = true;
  },
  GALLERY_DEACTIVATE(state) {
    state.galleryActive = false;
  },
};

const actions = {
  setGalleryEngin({ commit }, payload) {
    // do something async
    commit('SET_GALLERY_ENGIN', payload);
  },
};

const getters = {
  galleryEngin: (state) => {
    return state.galleryEngin;
  },
  galleryData: (state) => {
    return state.galleryData;
  },
  galleryActive: (state) => {
    return state.galleryActive;
  },
};
export default { state, mutations, actions, getters };
